import { styled } from '@mui/system';
import { Typography } from '@mui/material';

const RootDiv = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#FFFFFF',
  margin: '-16px 0px 0px 0px', // remove ModalContent's padding
  justifySelf: 'center',
  padding: '50px 30px 0px 30px',
  borderBottom: '1px solid #EAEAEA',
  width: '100%',
});

interface ContentTextProps {
  light?: boolean;
  bold?: boolean;
  highlight?: boolean;
  lineThrough?: boolean;
  float?: 'left' | 'right';
  marginRight?: number;
}

const ContextTextContianer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
});

const ContentText = styled(Typography, {
  shouldForwardProp: (prop) =>
    prop !== 'light' &&
    prop !== 'bold' &&
    prop !== 'highlight' &&
    prop !== 'lineThrough' &&
    prop !== 'float' &&
    prop !== 'marginRight',
})<ContentTextProps>(
  ({ light, bold, highlight, lineThrough, float, marginRight }) => ({
    fontFamily: 'Poppins',
    fontWeight: light ? '300' : bold ? '500' : '400',
    fontSize: '12px',
    lineHeight: '18px',
    letterSpacing: '0.16px',
    color: highlight ? '#731EFF' : '#414046',
    textDecoration: lineThrough ? 'line-through' : 'none',
    float: float,
    marginRight: marginRight,
  }),
);

const LineContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  margin: '6px 0px 6px 0px',
});

const GapContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
});

const TotalAmountContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  margin: '16px 0px 16px 0px',
});
const PayButtonContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  marginTop: '12px',
  marginBottom: '12px',
  cursor: 'pointer',
  paddingBottom: '0px',
  flexDirection: 'column',
});
export {
  RootDiv,
  ContextTextContianer,
  ContentText,
  LineContainer,
  PayButtonContainer,
  GapContainer,
  TotalAmountContainer,
};
